module.exports = __webpack_public_path__ + "static/vshe-e53e720fe44e7aa4bf9a1a6c746dbabb.png";